import React, { FunctionComponent } from 'react';
import { TextArea } from '../../atoms/textArea';
import classnames from 'classnames';

type Props = {
  target: string;
  text: string;
  handleChange: (target: string, value: string) => void;
  fromEntry?: boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  target,
  text,
  handleChange,
  fromEntry,
}) => {
  return (
    <div className="person__show__modal__inner">
      <p className="person__show__modal__inner--title">自己紹介文を入力して保存してください</p>
      <TextArea
        className={classnames(
          'person__show__modal__inner--textarea',
          { small: fromEntry }
        )}
        placeholder="自己紹介文を入力してください"
        onChanged={handleChange}
        name={target}
        value={text}
        maxLength={2000}
      />
      <p className="person__show__modal__inner--textarea--words">
        <span>
          残り<span className="red">{text ? 2000 - text.length : 2000}</span>文字
        </span>
      </p>
    </div>
  );
};
